module.exports = __webpack_public_path__ + "c8f268b2e3f58be9921bf212efdc2143.fbx";